import { existsSync, readFileSync } from "node:fs";
import { join } from "node:path";

/**
 * Read `.fernignore` patterns from the SDK output directory.
 *
 * Single source of truth for every surface that constructs a
 * `ReplayDetector`: the patterns scope which files survive into patch
 * content, which in turn determines the content hash a commit materializes
 * to. A detector built without these patterns computes different hashes
 * for commits touching `.fernignore`-protected files — silently breaking
 * dedupe and tombstone checks.
 */
export function readFernignorePatterns(outputDir: string): string[] {
    const fernignorePath = join(outputDir, ".fernignore");
    if (!existsSync(fernignorePath)) return [];
    return readFileSync(fernignorePath, "utf-8")
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line && !line.startsWith("#"));
}
